import React from 'react';
import { AlertTriangle, CheckCircle } from 'lucide-react';
import { FreeEventLimit } from '../../../hooks/useFreeEventLimit';

interface FreeEventLimitNoticeProps {
  limitInfo: FreeEventLimit;
}

const FreeEventLimitNotice: React.FC<FreeEventLimitNoticeProps> = ({ limitInfo }) => {
  if (limitInfo.isLoading) {
    return (
      <div className="alert alert-info mb-4" role="status">
        Checking your free event limit...
      </div>
    );
  }

  if (limitInfo.error) {
    return (
      <div className="alert alert-danger mb-4" role="alert">
        <AlertTriangle size={16} className="me-2" />
        {limitInfo.error}
      </div>
    );
  }

  const isLimitReached = limitInfo.remaining === 0;
  return (
    <div
      className={`alert ${isLimitReached ? 'alert-danger' : 'alert-success'} mb-4`}
      role={isLimitReached ? 'alert' : 'status'}
    >
      {isLimitReached ? <AlertTriangle size={16} className="me-2" /> : <CheckCircle size={16} className="me-2" />}
      <strong>{isLimitReached ? 'Limit reached' : 'Free event allowance'}</strong>
      <span className="ms-2">
        Created: {limitInfo.created} | Limit: {limitInfo.limit} | Remaining: {limitInfo.remaining}
      </span>
    </div>
  );
};

export default FreeEventLimitNotice;
